<template>
	<div class="categ_info" v-if="obj_to_null(this.city)">
		<info_field f_uniq="ct"
					f_type="title"
					:is_disabled="false"
					@update_categ="change_atr"
					:f_title="__t('NAME')"
					:f_val="cur_city.title">

		</info_field>
		<info_field
            f_uniq="cid"
            f_type="uniq_id"
            :is_disabled="false"
            @update_categ="change_atr"
            :f_title="__t('UNIQ_PROV_CODE')"
            :f_val="cur_city.uniq_id">
        </info_field>

        <info_field
            f_uniq="cid3"
            :f_title="__t('UNIQ_ID_CODE')"
            :f_val="cur_city.id.toString()">
        </info_field>

		<div class="form-group">
			<label class="form-label" for="name-f">{{__t("DATE_CREATE")}}</label>
			<div class="input-group">
				<div class="input-group-prepend">
						<span class="input-group-text text-success">
							<i class="fal fa-calendar-edit fs-xl"></i>
						</span>
				</div>
				<input type="text" class="form-control" id="name-f" disabled v-model="cur_city.added">
				<input type="text" class="form-control" id="name-l" disabled v-model="cur_city.updateAt">
			</div>
		</div>
	</div>

</template>

<script>
import Info_field from "../../../sys/info_field";

export default {
	name: "city_info",
	components: {Info_field},
	props : {
		city : {
			type : Object
		}
	},
	data() {
		return {
			cur_city : this.city,
			is_load: false,
		}
	},
	methods :  {
		change_atr(atr_name,atr_val) {
			if(this.city.hasOwnProperty(atr_name)) {
				this.city[atr_name] = atr_val;
			}
		}
	},
	computed : {
		is_disabled () {
			return this.cur_city.id > 0 && parseInt(this.cur_city.provider_id) != 8;
		},
	},
}
</script>

<style scoped>

</style>
